import { useTransactionProjection } from "@/domains/analytics/hooks/useTransactionProjection";
import { FEATURE_FLAGS } from "@/config/featureFlags";
import { useAccounts, useAccountsBalance } from "@/hooks/useAccounts";
import { useBudget } from "@/hooks/useBudget";
import { useCategoriesBalance, useCategories } from "@/hooks/useCategories";
import { useInstallmentsBalance } from "@/hooks/useInstallments";
import { useSavingInstitutions, useSavingPockets } from "@/hooks/useSavingPockets";

export const useAnalyticsData = (cycleRange: { start: string; end: string }) => {
  const categoryBalance = useCategoriesBalance({
    billable_date_gte: cycleRange.start,
    billable_date_lte: cycleRange.end,
    category_total_expense: "desc",
  });
  const projection = useTransactionProjection({
    projection_date: cycleRange.start,
    baseline_cycles: 3,
  });
  const categories = useCategories();
  const budget = useBudget({
    billable_date_gte: cycleRange.start,
    billable_date_lte: cycleRange.end,
    amount: "desc",
  });
  const accountsBalance = useAccountsBalance({
    billable_date_gte: cycleRange.start,
    billable_date_lte: cycleRange.end,
    monthly_expense: "desc",
  });
  const accounts = useAccounts();
  const installments = useInstallmentsBalance();
  const savingPockets = useSavingPockets({ enabled: FEATURE_FLAGS.savingPockets });
  const savingInstitutions = useSavingInstitutions({ enabled: FEATURE_FLAGS.savingPockets });

  return {
    categoryBalanceData: categoryBalance.data,
    loadingCategoryBalance: categoryBalance.isLoading,
    projectionData: projection.data,
    categories: categories.data ?? [],
    budgetData: budget.data,
    loadingBudgetBalance: budget.isLoading,
    accountsBalanceData: accountsBalance.data,
    loadingAccountsBalance: accountsBalance.isLoading,
    accounts: accounts.data ?? [],
    installmentsBalanceData: installments.data,
    loadingInstallmentsBalance: installments.isLoading,
    savingPockets: savingPockets.data ?? [],
    isLoadingSavingPockets: savingPockets.isLoading,
    savingInstitutions: savingInstitutions.data ?? [],
  };
};
